import { STATES } from '@components/common/helpers/state-helper';

import { getByKey } from '@utils/localstorage';
import { IAddress } from '@interfaces';
import { useInitFormGift } from '@v2/hooks/form';
import { useFormState } from '@app/store/rtk.form.selectors';

const defaultAddress = {
    address1: '',
    address2: '',
    city: '',
    postcode: '',
    state: '',
} as IAddress;

const defaultGiftForm = {
    amount: { value: 50, label: '$50' },
    delivery: '',
    deliveryDate: '',
    message: '',
    customer: {
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
    },
    billingAsShipping: true,
    customerAddress: {
        ...defaultAddress
    },
    billingAddress: {
        ...defaultAddress
    },
    recipient: {
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
    },
    recipientAddress: {
        ...defaultAddress
    },
}

export function mapForm(data: any, user: any) {
    let newData = Object.assign({}, data);
    let customer = Object.assign({}, data.customer);
    let customerAddress = Object.assign({}, data.customerAddress);
    let billingAddress = Object.assign({}, data.billingAddress);

    const stateShipping = STATES.find(obj => obj.value === customerAddress.state);
    const stateBilling = STATES.find(obj => obj.value === billingAddress.state);

    customer.firstName = user.firstName ? user.firstName : '';
    customer.lastName = user.lastName ? user.lastName : '';
    customer.email = user.email ? user.email : '';
    customer.phone = user.phone ? user.phone : '';
    customerAddress = user.shippingAddress ? user.shippingAddress : customerAddress;
    customerAddress = { ...customerAddress, state: (stateShipping && stateShipping.value)
        ? stateShipping.value
        : customerAddress.state };
    billingAddress = user.billingAddress ? user.billingAddress : billingAddress;
    billingAddress = { ...billingAddress, state: (stateBilling && stateBilling.value)
        ? stateBilling.value
        : billingAddress.state };

    newData.customer = Object.assign({}, customer);
    newData.customerAddress = Object.assign({}, customerAddress);
    newData.billingAddress = Object.assign({}, billingAddress);

    return newData;
}

export async function useInitGiftForm() {
    const storageData = getByKey('checkout-gift');

    useInitFormGift('checkout-gift', storageData || defaultGiftForm);
}

export function useGiftForm() {
    const storageData = getByKey('checkout-gift');

    return useFormState('checkout-gift') || storageData || defaultGiftForm;
}